// extracted by mini-css-extract-plugin
module.exports = {"buttons":"InventoryAccessories_buttons__1jv2b"};